import React, { useContext, useState } from 'react';
import {
  CForm,
  CModal,
  CModalHeader,
  CFormGroup,
  CModalBody,
  CModalFooter,
  CLabel,
  CButton,
} from '@coreui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { connect, DispatchProp } from 'react-redux';
import classNames from 'classnames';
import { get } from 'lodash';
import { UserInfo } from '../../../shared/models/user';
import { Job, ReassignJobPayload } from '../../../shared/models/jobs';
import { RootState } from '../../../store/state';
import { selectTechnicians } from '../../../store/selectors/user.selectors';
import LoadingButton from '../../../shared/components/LoadingButton';
import { ReassignJob } from '../../actions';
import { ConfigContext } from '../../../shared/contexts/journeyConfig.context';
import GuiSelect from '../../../shared/components/form/select/Select';

const DEFAULT_TECHNICIAN = -1;

const validationSchema = Yup.object({
  technician: Yup.number().required('Technician is required'),
});

const initialValues: ReassignJobPayload = {
  technician: DEFAULT_TECHNICIAN,
}

export interface ReassignJobProps extends DispatchProp {
  jobs: Job[];
  show: boolean;
  close: () => void;
  technicians: UserInfo[];
}

const ReassignModal = (props: ReassignJobProps) => {
  const { jobs, show, close, technicians, dispatch } = props;
  const [saving, setSaving] = useState(false);
  const labels = useContext(ConfigContext);

  const onSubmit = (values: ReassignJobPayload) => {
    setSaving(true);
    Promise
      .all(jobs.map(job => dispatch(new ReassignJob(job._id, values))))
      .then(() => close())
      .finally(() => setSaving(false));
  }

  initialValues.technician = DEFAULT_TECHNICIAN;
  if (jobs.length === 1) {
    initialValues.technician = jobs[0].agent_id
  }

  const formik = useFormik({ initialValues, validationSchema, onSubmit });

  const isInvalid = (fieldName: string) => get(formik.touched, fieldName) && get(formik.errors, fieldName);

  return (
    <CModal className="mt-5 pt-5" id="reassign-modal" show={ show } onClose={ close } closeOnBackdrop={ false }>
      <CModalHeader closeButton>Reassign {labels.task}</CModalHeader>
      <CForm onSubmit={ formik.handleSubmit }>
        <CModalBody>

          <CFormGroup>
            <CLabel htmlFor="technician">{labels.agent}</CLabel>
            <GuiSelect
              options={technicians.map(tech => ({ label: tech.name, value: tech.id}))}
              id="technician"
              name="technician"
              className={classNames({'is-invalid': isInvalid('technician')})}
              onChange={(val) => formik.setFieldValue('technician', val)}
              value={formik.getFieldProps('technician').value}
            />
          </CFormGroup>

        </CModalBody>
        <CModalFooter className="glympse-footer">
          {/* eslint-disable-next-line eqeqeq */}
          <div className="glympse-btnWrapper">
            <LoadingButton
              color='info'
              type='submit'
              className="pl-5 pr-5 bg-color-orange pl-5 pr-5 border-0 roundedBtn roundBottomShadow"
              isLoading={ saving }
            >
              Assign
            </LoadingButton>
          </div>
          <div className="glympse-btnWrapper">
            <CButton className="glympse-cancelBtn" color="light" shape="rounded-pill" variant="ghost" onClick={ close }>Cancel</CButton>
          </div>
        </CModalFooter>
      </CForm>
    </CModal>
  );
};

const mapStateToProps = (state: RootState) => ({
  technicians: selectTechnicians(state),
});

export default connect(mapStateToProps)(ReassignModal);
